import Icon from './Icon.vue'

export default {
  Icon
}



// WEBPACK FOOTER //
// ./src/components/icons/index.js